import { Component, Injector, Optional } from '@angular/core';

import { SoortTempService } from 'src/app/core/service/soort-temp.service';
import { SoortTemperatuur } from 'src/app/core/dto/soort-temp';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';

@Component({
    selector: 'c-i-j-borculo-soort-temp-collection',
    templateUrl: './soort-temp-collection.component.html'/*,
    styleUrls: ['./soort-temp-collection.component.css'] */
})
export class SoortTempCollectionComponent extends PagedCollectionComponent<SoortTemperatuur> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<SoortTemperatuur>([
		{ colDef: 'soortTemp', prop: x => x.omschrijving, searchable: SearchableType.String }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: SoortTempService, @Optional() protected filter: Filter<SoortTemperatuur>, injector: Injector) {
        super('/soortTemp/soortTemp', injector, SoortTemperatuur);

        this.filter.onGetChipLabel(x => x.omschrijving, () => 'Omschrijving');
    }
}